import { pipe, pathOr, map, prop } from 'ramda';

export const connectionNodes = pipe(pathOr([], ['edges']), map(prop('node')));
